<template>
    <section class="c-login">
        <div class="c-login__body">

            <forgot-password-email-form/>

        </div>
    </section>
</template>

<script>
    import ForgotPasswordEmailForm from '../../components/forms/ForgotPasswordEmailForm.vue';

    export default {
        components: { ForgotPasswordEmailForm },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .c-login {
        display: grid;
        height: 100%;

        &__body {
            align-self: center;
            justify-self: center;
            padding: 0 grid(1);

            @include media-breakpoint-up(md) {
                margin: 0 auto;
                padding: 0;
                width: grid(12, lg);
            }
        }
    }
</style>
